import { css } from '@emotion/core'
import * as MQ from 'styles/media-queries'
import { measures } from 'styles/variables'

const { unit } = measures

export const rowHeight = css`
  ${MQ.PHONES} {
    height: ${unit * 14}px;
  }
`

export const select = css`
  color: red;
  font-size: 20px;
  fontsize: 20px;
`
